import bundledConfig from "./auth.defaults.json";

const firstConfiguredValue = (env, names) => {
  for (const name of names) {
    const value = env?.[name];
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }
  return undefined;
};

const normalizeDomain = (domain) =>
  domain?.replace(/^https?:\/\//i, "").replace(/\/+$/, "");

export const resolveAuthConfig = ({
  env = process.env,
  origin = typeof window !== "undefined" ? window.location.origin : undefined,
} = {}) => {
  const domain = normalizeDomain(
    firstConfiguredValue(env, [
      "REACT_APP_AUTH0_DOMAIN",
      "REACT_APP_Auth0_domain",
    ]) || bundledConfig.domain
  );
  const clientId =
    firstConfiguredValue(env, [
      "REACT_APP_AUTH0_CLIENT_ID",
      "REACT_APP_Auth0_clientId",
    ]) || bundledConfig.clientId;
  const audience =
    firstConfiguredValue(env, [
      "REACT_APP_AUTH0_AUDIENCE",
      "REACT_APP_Auth0_audience",
    ]) || bundledConfig.audience;
  const configuredRedirectUri = firstConfiguredValue(env, [
    "REACT_APP_AUTH0_REDIRECT_URI",
    "REACT_APP_URL",
  ]);
  const redirectUri =
    configuredRedirectUri || (origin ? `${origin.replace(/\/+$/, "")}/` : undefined);

  if (!domain || !clientId || !audience || !redirectUri) {
    throw new Error(
      "Auth0 configuration is incomplete. Check the domain, client ID, audience, and redirect URI."
    );
  }

  return { domain, clientId, audience, redirectUri };
};
